module.exports = __webpack_public_path__ + "img/BlinkArt_Sword9_Purple.72876951.png";